import React from 'react';
import { Phone, ChevronDown } from 'lucide-react';
import { bandInfo } from '../data/mock';

const Hero = () => {
  const scrollToAbout = () => {
    const element = document.querySelector('#about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-black">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={bandInfo.heroImage}
          alt={bandInfo.name}
          className="w-full h-full object-cover object-top opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/50 to-black" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-transparent to-black/80" />
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gold-400/5 rounded-full blur-[100px]" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-gold-600/5 rounded-full blur-[100px]" />
      
      {/* Corner Decorations */}
      <div className="absolute top-20 left-8 w-32 h-[1px] bg-gradient-to-r from-gold-400/50 to-transparent" />
      <div className="absolute top-20 left-8 w-[1px] h-32 bg-gradient-to-b from-gold-400/50 to-transparent" />
      <div className="absolute bottom-20 right-8 w-32 h-[1px] bg-gradient-to-l from-gold-400/50 to-transparent" />
      <div className="absolute bottom-20 right-8 w-[1px] h-32 bg-gradient-to-t from-gold-400/50 to-transparent" />

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 text-center pt-20">
        {/* Logo */}
        <div className="mb-10 animate-fade-in flex justify-center">
          <img
            src={bandInfo.logo}
            alt={bandInfo.name}
            className="h-32 sm:h-40 md:h-48 w-auto"
          />
        </div>

        {/* Decorative Line */}
        <div className="w-24 h-[1px] bg-gradient-to-r from-transparent via-gold-400 to-transparent mx-auto mb-8 animate-fade-in-delay" />

        {/* Tagline */}
        <p className="text-xl sm:text-2xl md:text-3xl text-gold-300 font-light mb-6 tracking-[0.2em] uppercase animate-fade-in-delay">
          {bandInfo.tagline}
        </p>

        {/* Description */}
        <p className="text-white/60 text-lg sm:text-xl max-w-2xl mx-auto mb-12 leading-relaxed font-light animate-fade-in-delay-2">
          Profesionalni bend za sve vrste proslava na teritoriji cele Srbije
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-16 animate-fade-in-delay-3">
          <a href={`tel:${bandInfo.phone.replace(/\s/g, '')}`}>
            <button className="btn-gold px-10 py-4 text-sm tracking-[0.2em] uppercase flex items-center gap-3 rounded-none">
              <Phone className="w-4 h-4" />
              {bandInfo.phone}
            </button>
          </a>
        </div>

        {/* Quick Info */}
        <div className="flex flex-wrap items-center justify-center gap-8 text-white/50 text-sm tracking-wider animate-fade-in-delay-3">
          <span>{bandInfo.territory}</span>
          <span className="w-1 h-1 bg-gold-400 rounded-full" />
          <span>{bandInfo.email}</span>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToAbout}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 text-gold-400/50 hover:text-gold-400 transition-colors duration-300 animate-float"
      >
        <ChevronDown className="w-8 h-8" />
      </button>
    </section>
  );
};

export default Hero;
